import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { useAppContext } from '../../../../Services/AppContext';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import ECardMoveFileToHealthDocumentation from './ECardMoveFileToHealthDocumentation';
import { FileToShare } from '../ECard/ECard';
import { Size } from '../../../../Enums/Size.enum';

interface Props {
	opened: boolean;
	onClose: () => void;
	patientId: string;
	targetPatientId: string;
	filesToShare: FileToShare[];
	onSuccess: () => void;
	isPatientsConsentRequired: boolean;
}

const ECardMoveFileToHealthDocumentationModal: React.FC<Props> = ({
	opened,
	onClose,
	filesToShare,
	targetPatientId,
	patientId,
	onSuccess,
	isPatientsConsentRequired,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<div>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.LG}>
				<Modal.Header title={'component.eCard.moveFiles'} />
				<Modal.Content>
					<ECardMoveFileToHealthDocumentation
						onSuccess={onSuccess}
						filesToShare={filesToShare}
						targetPatientId={targetPatientId}
						patientId={patientId}
						isPatientsConsentRequired={isPatientsConsentRequired}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default ECardMoveFileToHealthDocumentationModal;
